export default {"src":"/_next/static/media/highcontrast-font.a2b3584f.svg","height":40,"width":40};